package top.wcpe.allincore.dsl.compiler.ast

/**
 * Stage 11：顶层块种类，用于区分 `screen { ... }` 与 `hud { ... }`。
 *
 * 设计动机（RFC §4.1）：
 * - 两种块共享完全相同的 IR schema（state / actions / animations / root / theme / funs / ...），
 *   在 DSL 语法层完全等价（含 onKey / onMouseDown / onMouseUp / onMouseMove / open / close）。
 * - 因此复用 [ScreenAst] 节点与 [top.wcpe.allincore.dsl.compiler.parse.ScreenParser]，
 *   通过本枚举字段在 AST 层标注语法来源，避免引入并行的 HudAst/HudParser 造成复制粘贴。
 *
 * 该字段不进入 IR；仅供编译入口（pipeline / 服务端注册表分类）使用。
 */
enum class ScreenKind {
    /** 标准 `screen { ... }` 块：完整功能。 */
    SCREEN,

    /** Stage 11：`hud { ... }` 块：与 screen 在 DSL 语法层完全等价。 */
    HUD,
}
